import { useProductApi } from './useProductApi';
import { useProductGetters } from './useProductGetters';
import { useProductHelpers } from './useProductHelpers';

import type { UseProduct } from './types';
export function useProduct(): UseProduct {
  return {
    ...useProductApi(),
    ...useProductGetters(),
    ...useProductHelpers(),
  };
}
